<template>

  <rate-calendar-popup :title="item.locationProduct.product?.name ?? '(unknown product)'">

    <template v-if="sortedVlps.length === 0">
      <p>No venues are live for this product.</p> <!-- TODO: i18n -->
    </template>

    <template v-else>

      <table class="calendar-popup-table">
        <thead>
          <tr>
            <th scope="col">{{ $t('titles.venue') }}</th>
            <th scope="col">{{ $t('titles.default_cost') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="vlp in sortedVlps">
            <td>{{ vlp.venue?.name ?? '(unknown venue)' }}</td>
            <td>
              <template v-if="vlp.venueTiers.length > 0">
                <template v-for="(venueTier, i) in vlp.venueTiers">
                  {{ currencyFormatter.format(venueTier.tierPrice) }}
                  up to {{ percentageFormatter.format(venueTier.tierInventoryPercentage) }}
                  <br v-if="i+1 < vlp.venueTiers.length" />
                </template>
              </template>
              <template v-else>
                {{ currencyFormatter.format(vlp.defaultPrice) }}
              </template>
            </td>
          </tr>
        </tbody>
      </table>

    </template>

  </rate-calendar-popup>

</template>

<script setup lang="ts">

import { computed } from 'vue'

// components
import RateCalendarPopup from './RateCalendarPopup.vue'

// misc
import type { EventBaseItem } from '../types'
import type { VenueLocationProduct } from '../../../../../models/VenueLocationProduct'
import { currencyFormatter, percentageFormatter } from '../../../../../utils/formatters'

interface Props {
  item: EventBaseItem
}

const props = defineProps<Props>()

const sortedVlps = computed<VenueLocationProduct[]>(() => {
  return props.item.locationProduct.venueLocationProducts.sort((vlp1, vlp2) => {
    const name1 = vlp1.venue?.name ?? '(unknown venue)'
    const name2 = vlp2.venue?.name ?? '(unknown venue)'
    if (name1 === name2) {
      return 0
    }
    return name1 > name2 ? 1 : -1
  })
})

</script>
